/**
 * Organization Question Bank API – all endpoints used by question bank pages.
 * Base path: /admin/questionbank (organization question bank routes mounted in backend organization routes).
 */
import { GET, POST, PUT } from "../../apiController";

const ORG_QUESTION_BANK = '/admin/questionbank';

/** GET — all questions, options, and tags for reporting / Excel */
export const getQuestionBankReport = () => {
  return GET(`${ORG_QUESTION_BANK}/report`);
};

// Get all question bank questions with pagination
export const getQuestionBank = (data) => {
  const payload = {
    page: data.page || 1,
    limit: data.limit || 10,
    search: data.search || "",
    question_level: data.question_level || "",
  };
  return POST(`${ORG_QUESTION_BANK}/questions`, payload);
};

// Create new question in question bank
export const createQuestionBank = (data) => {
  return POST(`${ORG_QUESTION_BANK}/add_question`, data);
};

// Update existing question in question bank
export const updateQuestionBank = (data) => {
  return PUT(`${ORG_QUESTION_BANK}/update_question`, data);
};

// Delete question from question bank
export const deleteQuestionBank = (data) => {
  return POST(`${ORG_QUESTION_BANK}/delete_question`, data);
};

// Get question by ID from question bank
export const getQuestionBankById = (data) => {
  return POST(`${ORG_QUESTION_BANK}/get_question_by_id`, data);
};

// Get all question tags
export const getTags = () => {
  return GET(`${ORG_QUESTION_BANK}/question_tags`);
};

// Delete question tag
export const deleteQuestionTag = (data) => {
  return POST(`${ORG_QUESTION_BANK}/delete_question_tag`, data);
};

export const bulkImportQuestionBank = (data) => {
  return POST(`${ORG_QUESTION_BANK}/bulk_import`, data);
};

export const getQuestionImportConfig = () => GET(`${ORG_QUESTION_BANK}/import_config`);
